import MenuItem from "@material-ui/core/MenuItem";
import React from "react";
import { Link } from "react-router-dom";
import { UserMenuItemSchema } from "./models";

interface UserMenuItemProps {
  schema: UserMenuItemSchema;
  onMenuItemClick: () => void;
}

export const UserMenuItemComponent = (props: UserMenuItemProps) => {
  const { schema, onMenuItemClick } = props;
  const { label, linkUrl } = schema;

  return (
    <MenuItem component={Link} to={linkUrl} onClick={onMenuItemClick}>
      {label}
    </MenuItem>
  );
};

export const UserMenuItem = UserMenuItemComponent;
